

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"13","height":"13"}, rest), [h('path', {"fill":"currentColor","fill-rule":"nonzero","d":"M2.986 0c.024 0 .052.003.08.007L2.982 0a.491.491 0 0 1 .243.063l.022.014c.018.01.035.023.051.036l.01.01c.01.007.019.015.027.024l2.482 2.48a.503.503 0 0 1 0 .706c-.1.1-.227.147-.354.147a.495.495 0 0 1-.353-.147L3.48 1.707V12.5c0 .273-.226.5-.5.5a.504.504 0 0 1-.5-.5L2.48 1.706.852 3.333a.504.504 0 0 1-.707 0 .503.503 0 0 1 0-.706L2.627.147a.501.501 0 0 1 .172-.113L2.81.031A.425.425 0 0 1 2.98 0h.005Zm7.027 0c.273 0 .5.227.5.5l-.001 10.8 1.636-1.634a.504.504 0 0 1 .707 0 .503.503 0 0 1 0 .707l-2.482 2.48a.513.513 0 0 1-.36.147l-.062-.006h-.01l.072.006a.49.49 0 0 1-.388-.186l-2.44-2.44a.503.503 0 0 1 0-.708.504.504 0 0 1 .706 0l1.621 1.62V.5c0-.273.227-.5.5-.5Z"}, [])]);
};

        